var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',{staticClass:"flex-start"},[(_vm.item.icon)?_c('span',{staticClass:"menu-popup__icon"},[(_vm.item.loading)?_c('mdicon',{staticClass:"spinner",attrs:{"name":"loading","size":"24"}}):_c('mdicon',{attrs:{"name":_vm.item.icon,"size":"24"}})],1):_vm._e(),_c('span',{staticClass:"menu-popup__text"},[_vm._v(" "+_vm._s(_vm.item.caption)+" ")])])
}
var staticRenderFns = []

export { render, staticRenderFns }